<template>
  <v-navigation-drawer v-model="$store.sidebar.active" :clipped="$vuetify.breakpoint.lgAndUp" app>
    <!-- header del sidebar -->
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title text-center">
          <v-img src="../../assets/img/logo.png" aspect-ratio="2" contain></v-img>
          {{titulo}}
        </v-list-item-title>
        <v-list-item-subtitle>{{descripcion}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- divisor -->
    <v-divider></v-divider>

    <!-- menu del sidebar -->
    <v-list dense nav>
      <template v-for="m in menu">
        <!-- MENU SIN HIJOS -->
        <v-list-item
          v-if="!m.submenu || m.submenu.length == 0"
          :key="m.id"
          link
          :to="{path: m.ruta}"
          >
          <!-- icono del menu -->
          <v-list-item-icon>
            <v-icon :color="'red'">{{ m.icono }}</v-icon>
          </v-list-item-icon>

          <!-- texto del menu -->
          <v-list-item-content>
            <v-list-item-title>{{ m.nombre }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- MENU CON HIJOS -->
        <v-list-group 
        v-if="m.submenu && m.submenu.length > 0"
          :key="m.id"
          >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon :color="m.color">{{ m.icono }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ m.nombre }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-for="sm in m.submenu">
            <v-list-item link :to="{path: sm.ruta}">
              <!-- icono del menu -->
              <v-list-item-icon>
                <v-icon :color="sm.color">{{ sm.icono }}</v-icon>
              </v-list-item-icon>

              <!-- texto del menu -->
              <v-list-item-content>
                <v-list-item-title>{{ sm.nombre }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    titulo: "",
    descripcion: "",
    menu: null,
  },
  data() {
    return {};
  },
  methods: {
    sidebarStatus() {
      return this.$store.sidebar.active;
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>